import { useEffect, useState } from "react";
import { Box, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import SearchBar from "../../components/SearchBar";
import React from "react";
import {
  useLazyGetUsersQuery,
  useUpdateUsersMutation,
} from "../../services/user";
import { isValidInput } from "../../utils/validations";

const CustomerTopbar = ({ setValue }: { setValue: any }) => {
  const [searchTerm, setSearchTerm] = useState("");

  const [Status, setStatus] = React.useState("default");
  const handleStatusChange = (event: SelectChangeEvent) => {
    setStatus(event.target.value as string);
  };
  const [Plan, setPlan] = React.useState("default");
  const handlePlanChange = (event: SelectChangeEvent) => {
    setPlan(event.target.value as string);
  };
  const [isLoading, setIsLoading] = useState(false);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [page, setPage] = useState(1);
  const [data, setData] = useState<any[]>([]);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [userUpdate] = useUpdateUsersMutation();
  const [getUser] = useLazyGetUsersQuery();

  const getUserList = async () => {
    setIsLoading(true);
    try {
      const response = await getUser({
        length: 10,
        start: page,
        search: debouncedSearchTerm,
      }).unwrap();
      if (response.status === 200) {
        setData(response?.data?.response_object || []);
        setTotalCount(response?.data?.total_records || 0);
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getUserList();
    setValue(() => debouncedSearchTerm);
  }, [debouncedSearchTerm, page]);
  return (
    <>
      <div className="table_header">
        <div className="left_s">
          <SearchBar
            placeholder="Search..."
            searchTerm={searchTerm}
            setDebouncedSearchTerm={setDebouncedSearchTerm}
            value={searchTerm}
            onCross={() => setSearchTerm("")}
            onChange={(val: any) => {
              if (isValidInput(val.target.value)) {
                setSearchTerm(val.target.value);
              }
            }}
          />
          <div className="form">
            <div className="control_group">
              <Select fullWidth value={Status} onChange={handleStatusChange}>
                <MenuItem disabled value="default">
                  Select Status
                </MenuItem>
                <MenuItem value="All">All</MenuItem>
                <MenuItem value="Active">Active</MenuItem>
                <MenuItem value="Inactive">Inactive</MenuItem>
                <MenuItem value="Suspended">Suspended</MenuItem>
              </Select>
            </div>
            <div className="control_group">
              <Select fullWidth value={Plan} onChange={handlePlanChange}>
                <MenuItem disabled value="default">
                  Select Plan
                </MenuItem>
                <MenuItem value="All">All</MenuItem>
                <MenuItem value="Free">Free</MenuItem>
                <MenuItem value="Premium">Premium</MenuItem>
                <MenuItem value="Family">Family</MenuItem>
                <MenuItem value="Creator">Creator</MenuItem>
              </Select>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomerTopbar;
